<template>
  <Item
    v-if="mold" 
    model="mold" 
    :item="mold"
    :prev="mold.prev"
    :next="mold.next"
    :nextUrl="mold.nextUrl"
    :status="status"
    @onFetchMore="updateItems"
    @onRemoveItem="removeItem"
  >
    <PonyCard
      :key="item.id"
      v-for="item in ponies"
      :user="currentUser"
      :item="item"
      :authenticated="authenticated"
      :url="url(item.id)"
    />
  </Item>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { showPrompt } from '../../utils/helpers'
import Item from '../../layouts/Item/Item';
import PonyCard from '../../components/PonyCard/PonyCard';

export default {
  name: 'Mold',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      num: 12
    };
  },
  components: {
    PonyCard,
    Item
  },
  mounted() {
    // fetch this even if the mold getter returns a mold
    // we need to make sure that we fetch the mold's groupigs and prev/next
    this.fetchMold(this.slug, this.num);
  },
  computed: {
    ...mapGetters('mold', ['getBySlug']),
    ...mapGetters('pony', ['getPoniesByMold']),
    ...mapState('currentUser', ['authenticated', 'currentUser']),
    ...mapState('mold', ['status', 'nextUrl']),
    mold() {
      const mold = this.getBySlug(this.slug);

      return mold ? mold : {};
    },
    ponies() {
      const ponies = this.getPoniesByMold(this.slug);

      return ponies ? ponies : [];
    }
  },
  methods: {
    ...mapActions('mold', ['FETCH', 'FETCH_MORE_PONIES', 'REMOVE']),
    hasItems(items) {
    return (items.length && items[0] !== 'no items');
    },
    fetchMold(slug) {
      // if (!Object.keys(this.mold).length) {
        this.FETCH({ slug, num: this.num });
      // }
    },
    updateItems() {
      this.FETCH_MORE_PONIES({ id: this.mold.id, url: this.mold.nextUrl });
    },
    removeItem({ id }) {
      showPrompt();

      this.REMOVE({ id });
    },
    url(id) {
      return `/pony/${id}`
    }
  },
  watch: {
    $route() {
      this.fetchMold(this.slug, this.num);
    }
  }
};
</script>

